import { configure } from "mobx"
import { enableStaticRendering } from "mobx-react"
import { isServer } from "@lib/isomorphic"
import { config } from "@lib/config"

import { ResponsiveModel } from "./responsive.model"
import { SubscriptionModel } from "./subscription.model"
import { ModalModel } from "./modal.model"
import { FaqModel } from "./faq.model"
import { AnalyticsModel } from "./analytics.model"
import { BlogModel } from "./blog.model"
import { GlobalModel } from "./global.model"
import { PaymentTipsModel } from "./payment-tips.model"
import { InappPurchasesModel } from "./inapp-purchases.model"
import { ContactUsModel } from "./contact-us.model"
import { HuaweiTipsModel } from "./huawei-tips.model"
import { VacanciesModel } from "./vacancies.model"
import { AndroidPaymentsModel } from "./android-payments.model"
import { LegalModel } from "./legal.model"
import { TeamPageModel } from "./team-page.model"
import { GDPRModel } from "./gdpr.model"

configure({ enforceActions: "observed" })
enableStaticRendering(isServer())

interface InitParams {
  ResponsiveModel: ResponsiveModel
  AnalyticsModel: AnalyticsModel
  GlobalModel: GlobalModel
  BlogModel: BlogModel
  SubscriptionModel: SubscriptionModel
  ModalModel: ModalModel
  FaqModel: FaqModel
  PaymentTipsModel: PaymentTipsModel
  InappPurchasesModel: InappPurchasesModel
  ContactUsModel: ContactUsModel
  HuaweiTipsModel: HuaweiTipsModel
  VacanciesModel: VacanciesModel
  AndroidPaymentsModel: AndroidPaymentsModel
  LegalModel: LegalModel
  TeamPageModel: TeamPageModel
  GDPRModel: GDPRModel
}

export class AppModels {
  ResponsiveModel!: ResponsiveModel
  AnalyticsModel!: AnalyticsModel
  GlobalModel!: GlobalModel
  BlogModel!: BlogModel
  SubscriptionModel!: SubscriptionModel
  ModalModel!: ModalModel
  FaqModel!: FaqModel
  PaymentTipsModel!: PaymentTipsModel
  InappPurchasesModel!: InappPurchasesModel
  ContactUsModel!: ContactUsModel
  HuaweiTipsModel!: HuaweiTipsModel
  VacanciesModel!: VacanciesModel
  AndroidPaymentsModel!: AndroidPaymentsModel
  LegalModel!: LegalModel
  TeamPageModel!: TeamPageModel
  GDPRModel!: GDPRModel

  hydrated = false

  init({
    ResponsiveModel,
    AnalyticsModel,
    GlobalModel,
    BlogModel,
    SubscriptionModel,
    ModalModel,
    FaqModel,
    PaymentTipsModel,
    InappPurchasesModel,
    ContactUsModel,
    HuaweiTipsModel,
    VacanciesModel,
    AndroidPaymentsModel,
    LegalModel,
    TeamPageModel,
    GDPRModel,
  }: InitParams) {
    this.ResponsiveModel = ResponsiveModel
    this.AnalyticsModel = AnalyticsModel
    this.GlobalModel = GlobalModel
    this.BlogModel = BlogModel
    this.SubscriptionModel = SubscriptionModel
    this.ModalModel = ModalModel
    this.FaqModel = FaqModel
    this.PaymentTipsModel = PaymentTipsModel
    this.InappPurchasesModel = InappPurchasesModel
    this.ContactUsModel = ContactUsModel
    this.HuaweiTipsModel = HuaweiTipsModel
    this.VacanciesModel = VacanciesModel
    this.AndroidPaymentsModel = AndroidPaymentsModel
    this.LegalModel = LegalModel
    this.TeamPageModel = TeamPageModel
    this.GDPRModel = GDPRModel
  }

  // @ts-ignore
  hydrate(data) {
    this.hydrated = true
    this.GlobalModel.hydrate(JSON.parse(data?.GlobalModel))
    this.BlogModel.hydrate(JSON.parse(data?.BlogModel))
    this.SubscriptionModel.hydrate(JSON.parse(data?.SubscriptionModel))
    this.FaqModel.hydrate(JSON.parse(data?.FaqModel))
    this.ResponsiveModel.hydrate(JSON.parse(data?.ResponsiveModel))
    this.PaymentTipsModel.hydrate(JSON.parse(data?.PaymentTipsModel))
    this.InappPurchasesModel.hydrate(JSON.parse(data?.InappPurchasesModel))
    this.ContactUsModel.hydrate(JSON.parse(data?.ContactUsModel))
    this.HuaweiTipsModel.hydrate(JSON.parse(data?.HuaweiTipsModel))
    this.VacanciesModel.hydrate(JSON.parse(data?.VacanciesModel))
    this.AndroidPaymentsModel.hydrate(JSON.parse(data?.AndroidPaymentsModel))
    this.LegalModel.hydrate(JSON.parse(data?.LegalModel))
    this.TeamPageModel.hydrate(JSON.parse(data?.TeamPageModel))
    this.GDPRModel.hydrate(JSON.parse(data?.GDPRModel))

    config.hydrate(JSON.parse(data?.config))
  }

  serialize() {
    return {
      GlobalModel: JSON.stringify(this.GlobalModel.serialize()),
      BlogModel: JSON.stringify(this.BlogModel.serialize()),
      SubscriptionModel: JSON.stringify(this.SubscriptionModel.serialize()),
      FaqModel: JSON.stringify(this.FaqModel.serialize()),
      ResponsiveModel: JSON.stringify(this.ResponsiveModel.serialize()),
      PaymentTipsModel: JSON.stringify(this.PaymentTipsModel.serialize()),
      InappPurchasesModel: JSON.stringify(this.InappPurchasesModel.serialize()),
      ContactUsModel: JSON.stringify(this.ContactUsModel.serialize()),
      HuaweiTipsModel: JSON.stringify(this.HuaweiTipsModel.serialize()),
      VacanciesModel: JSON.stringify(this.VacanciesModel.serialize()),
      AndroidPaymentsModel: JSON.stringify(
        this.AndroidPaymentsModel.serialize(),
      ),
      LegalModel: JSON.stringify(this.LegalModel.serialize()),
      TeamPageModel: JSON.stringify(this.TeamPageModel.serialize()),
      GDPRModel: JSON.stringify(this.GDPRModel.serialize()),

      config: JSON.stringify(config.serialize()),
    }
  }
}
